
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin, inAppAlertLogin, WechatLogin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo, userInfo, voteNum } from './api';

const baseUrl = '0403yspxwap';

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  tabs: any[] = [
    {
      title: '活动规则',
      path: `/${baseUrl}/rule`,
      id: 1,
    },
    {
      title: '活动新闻',
      path: `/${baseUrl}/news`,
      id: 2,
    },
    {
      title: '报名链接',
      path: `/${baseUrl}/link`,
      id: 3,
    },
    // {
    //   title: '风采展示',
    //   path: `/${baseUrl}/list`,
    //   id: 4,
    // },
  ];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '2026“十大渝商”评选',
      url: location.href,
      subtitle: `2026“十大渝商”评选`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '2026“十大渝商”评选',
        subtitle: `2026“十大渝商”评选`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
